import * as React from "react";
import { styled } from "@mui/material/styles";
import {
  DataGrid,
  gridClasses,
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import { useWindowDimensions } from "hooks/useWindowDimensions";
import { useEffect } from "react";
import { useState } from "react";
import { Pagination, PaginationItem } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { kitchenHandler } from "../../redux/handlers";
import moment from "moment";
import { useRef } from "react";
const optionsMap = {
  "": "",
  DINE_IN: 1,
  TAKEAWAY: 2,
  DELIVERY: 3,
};
export default function KitchenTable({
  tabIndex,
  params,
  currentBranchPos,
  businessSlug,
}) {
  const { width, height } = useWindowDimensions();
  const dispatch = useDispatch();
  const kitchenTableData = useSelector((state) => state.kitchen.dataTable);

  const columns = [
    {
      field: "date",
      headerName: "วันที่",
      headerAlign: "start",
      align: "start",
      width: 150,
      renderCell: ({ row }) => {
        return <div className="text-[#6D788D]">{row.date}</div>;
      },
      sortable: false,
    },
    {
      field: "orderCode",
      headerName: "รหัสออเดอร์",
      headerAlign: "start",
      align: "start",
      maxWidth: (width * 10) / 100,

      renderCell: ({ row }) => {
        return <div className="text-[#6D788D]">{row.orderCode}</div>;
      },
      sortable: false,
    },
    {
      field: "queue",
      headerName: "คิวที่",
      headerAlign: "center",
      align: "center",
      maxWidth: (width * 10) / 100,
      width: 150,
      renderCell: ({ row }) => {
        return (
          <div className="text-[#2DC76D] font-bold text-20">{row.queue}</div>
        );
      },
      sortable: false,
    },
    {
      field: "tableNo",
      headerName: "โต๊ะ",
      headerAlign: "start",
      align: "start",
      width: 110,

      renderCell: ({ row }) => {
        return (
          <div className="text-[var(--color-blue-2)] font-bold text-20">
            {row.tableNo}
          </div>
        );
      },
      sortable: false,
    },

    {
      field: "name",
      headerName: "รายการ",

      minWidth: 300,
      renderCell: ({ row }) => {
        return (
          <div className="flex items-center">
            <img
              src={row.image}
              className="w-[40px] h-[40px] object-cover mr-2"
            />
            <div className="text-[#6D788D]  flex-fill">{row?.name}</div>
          </div>
        );
      },
      sortable: false,
    },
    {
      field: "รายละเอียด",
      headerName: "รายละเอียด",
      width: 200,
      renderCell: ({ row }) => {
        return (
          <div className={`flex flex-wrap gap-[min(1.46vw,15px)] `}>
            {row.details &&
              row.details.optionList &&
              row.details.optionList.map((v, i) => {
                return (
                  <div
                    className={`text-12 bg-[var(--color-light-red)] text-[var(--color-red)] px-[min(1.27vw,13px)] h-[min(2.13vw,22px)] flex items-center ${
                      row.details.optionList?.[0] === "" ? "hidden" : ""
                    }`}
                    key={i}
                  >
                    {v}
                  </div>
                );
              })}

            {row.details &&
              row.details.annotationList &&
              row.details.annotationList.map((v, i) => {
                return (
                  <div
                    className={`text-12 bg-[#FFF1EA] text-[#FF731D] px-[min(1.27vw,13px)] h-[min(2.13vw,22px)] flex items-center ${
                      row.details.annotationList?.[0] === "" ? "hidden" : ""
                    }`}
                    key={i}
                  >
                    {v}
                  </div>
                );
              })}

            {row.details &&
              row.details.ignoreList &&
              row.details.ignoreList.map((v, i) => {
                return (
                  <div
                    className={`text-12 bg-[var(--color-light-orange)] text-[var(--color-orange)] px-[min(1.27vw,13px)] h-[min(2.13vw,22px)] flex items-center  ${
                      row.details.ignoreList?.[0] === "" ? "hidden" : ""
                    }`}
                    key={i}
                  >
                    {v}
                  </div>
                );
              })}
          </div>
        );
      },
      sortable: false,
    },
    {
      field: "orderType",
      headerName: "รูปแบบ",
      headerAlign: "start",
      align: "start",
      width: 150,
      renderCell: ({ row }) => {
        return (
          <>
            {row.orderType == 1 ? (
              <div className="flex flex-wrap  w-100 items-center gap-[min(1.17vw,12px)]">
                <img
                  className="object-contain aspect-square w-[min(5.54vw,30px)] h-fit"
                  src="/img/icons/icon-kitchen-onsite.png"
                  alt=""
                />
                <div className=" font-[500]">
                  <div className="text-[14px] text-[#6D788D] lh-1">
                    ทานที่ร้าน
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            {row.orderType == 2 ? (
              <div className="flex flex-wrap  w-100 items-center gap-[min(1.17vw,12px)]">
                <img
                  className="object-contain aspect-square w-[min(5.54vw,30px)] h-fit"
                  src="/img/icons/icon-kitchen-take-home.png"
                  alt=""
                />
                <div className=" font-[500]">
                  <div className="text-[14px] text-[#6D788D] lh-1">
                    ซื้อกลับบ้าน
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}

            {row.orderType == 3 ? (
              <div className="flex flex-wrap  w-100 items-center gap-[min(1.17vw,12px)]">
                <img
                  className="object-contain aspect-square w-[min(5.54vw,30px)] h-fit"
                  src="/img/icons/icon-kitchen-delivery.png"
                  alt=""
                />
                <div className=" font-[500]">
                  <div className="text-[14px] text-[#6D788D] lh-1">
                    เดลิเวอรี่
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </>
        );
      },
      sortable: false,
    },
    {
      field: "pos",
      headerName: "POS",
      headerAlign: "start",
      align: "start",
      width: 180,
      renderCell: ({ row }) => {
        return (
          <div className="flex gap-[min(1.15vw,11.82px)]">
            <div className="flex flex-col items-center">
              <div className="text-14 text-[#6D788D] font-[300]">
                {row.timeServ.orderNo} : {row.timeServ.pos}
              </div>
            </div>
          </div>
        );
      },
      sortable: false,
    },
    {
      field: "time",
      headerName: "เวลาเสริฟ",
      headerAlign: "center",
      align: "center",
      width: 150,
      renderCell: ({ row }) => {
        return (
          <div className="flex items-center gap-[min(1.15vw,11.82px)]">
            <img
              className="object-contain aspect-square w-[min(2.61vw,27px)] h-fit"
              src={
                row.timeServ.isCancel
                  ? "/img/icons/icon-serv-red.svg"
                  : "/img/icons/icon-serv-green.svg"
              }
              alt=""
            />
            <div className="flex flex-col items-center">
              <div className="text-14 text-[#4A4A4A] font-[300]">
                {row.timeServ.time}
              </div>
            </div>
          </div>
        );
      },
      sortable: false,
    },
  ];

  const [rawData, setRawData] = useState({
    isLoading: false,
    data: [],
    total: 0,
    page: 1,
    pageSize: 5,
  });

  const [pageState, setPageState] = useState({
    isLoading: false,
    data: [],
    total: 0,
    page: 1,
    pageSize: 10,
  });
  const handlePageChange = (newPage) => {
    setPageState((old) => ({
      ...old,
      page: newPage + 1,
    }));
  };
  const isInitialFetch = useRef(true);
  useEffect(() => {
    const formatData = kitchenTableData?.data?.map((item) => ({
      id: item.id,
      date: moment(item.created_at).format("DD/MM/YYYY HH:mm"),
      orderCode: item.order.code,
      orderType: optionsMap[item.order.order_type],
      tableNo: item?.branchTable?.name ?? "",
      queue: item?.kitchenOrder?.queue,
      image: item.orderItem.product.image_path,
      name: item?.orderItem.product?.name ?? "",
      details: {
        annotationList: item?.orderItem.orderProductAnnotation?.map(
          (order) => order?.productAnnotationItem?.name ?? ""
        ),
        optionList: item?.orderItem.orderProductOption?.map(
          (order) => order?.productOptionItem?.name ?? ""
        ),
        ignoreList: item?.orderItem.orderProductSpecificOption?.map(
          (order) => order?.productSpecificOption?.name ?? ""
        ),
      },
      timeServ: {
        pos: item?.branchPosSelling?.branchPos?.name ?? "",
        orderNo: item?.branchPosSelling?.branchPos?.pos_id,
        time: moment(item.created_at).format("HH:mm"),
        isCancel: false,
      },
    }));

    setRawData((old) => ({
      ...old,
      isLoading: false,
      data: formatData,
      total: kitchenTableData.meta?.total,
    }));
  }, [kitchenTableData]);

  useEffect(() => {
    if (rawData) {
      const filterData = rawData.data;
      setPageState((old) => ({
        ...old,
        isLoading: false,
        data: filterData,
        total: rawData?.total,
      }));
    }
  }, [rawData]);
  useEffect(() => {
    const formatParams = {
      ...params,
      page: pageState.page,
      perPage: pageState.pageSize,
    };
    if (isInitialFetch.current) {
      dispatch(
        kitchenHandler.getKitchenHistory(
          businessSlug,
          formatParams,
          currentBranchPos
        )
      );
      isInitialFetch.current = false;
      return;
    }

    dispatch(
      kitchenHandler.getKitchenHistory(
        businessSlug,
        formatParams,
        currentBranchPos
      )
    );
  }, [
    businessSlug,
    currentBranchPos,
    dispatch,
    pageState.page,
    pageState.pageSize,
    params,
  ]);

  return (
    <div className="w-full ">
      <DataGrid
        pagination
        pageSizeOptions={[5, 10, 25]}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: pageState.pageSize,
            },
          },
        }}
        onPageChange={handlePageChange}
        rows={pageState.data || []}
        rowCount={pageState.total}
        loading={pageState.isLoading}
        columns={columns}
        columnHeaderHeight={
          (width * 5.96) / 100 > 61 ? 61 : (width * 5.96) / 100
        }
        getRowHeight={() => "auto"}
        disableColumnMenu={true}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
        }
        sx={{
          "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
            py: "min(0.98vw,10px)",
          },
          "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
            py: "min(0.98vw,10px)",
          },
          "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
            py: "min(0.98vw,10px)",
          },
        }}
        slots={{
          pagination: CustomPagination,
        }}
      />
    </div>
  );
}
function CustomPagination() {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  return (
    <div className="flex justify-center items-center">
      <div className="text-[#6D788D] mr-3">
        {" "}
        ทั้งหมด {apiRef.current.getRowsCount()} รายการ{" "}
      </div>
      <Pagination
        color="primary"
        variant="outlined"
        shape="rounded"
        page={page + 1}
        count={pageCount}
        renderItem={(props2) => <PaginationItem {...props2} disableRipple />}
        onChange={(event, value) => apiRef.current.setPage(value - 1)}
      />
    </div>
  );
}
